<template>
  <div class="footer">
    <div class="l">
      <div class="l_tent">
        <img
          style="width:104px"
          src="../../../assets/img/logo_bottom.png"
          alt=""
        />
        <div style="color: #64748B;margin-top: 16px;font-size: 14px;line-height: 26px;">
         网络游戏全链路AI智能体平台。由四川数字世界牵头、联合TOUKA GAMES共同打造，连接游戏开发者、广告平台与金融机构。
        </div>
      </div>
      <div class="l_tent1">
        <div class="link_list">
          <div class="link_title">产品服务</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">数据洞察</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">智能投放</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">资产融资</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">AI创作</div>
        </div>
        <div class="link_list">
          <div class="link_title">关于我们</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">公司介绍</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">加入我们</div>
        </div>
        <div class="link_list">
          <div class="link_title">帮助支持</div>
           <div class="link" @click="gourl('http://42.194.202.49/star-game/login')">使用文档</div>
           <div class="link" @click="showQrCode">帮助客服</div>
        </div>
      </div>
    </div>
    <div class="r">
      <div class="copyright">
        © 2026 星游聚. 四川数字世界文化科技有限公司 版权所有
      </div>
      <div class="beian" @click="toBn()">
        蜀ICP备2023022502号-1
      </div>
    </div>
    
    <!-- 优化：点击显示二维码弹层 -->
    <div
        v-if="qrCodeVisible"
        class="qr-code-modal"
        @click.self="qrCodeVisible = false"
      >
        <div class="qr-code-dialog">
          <img
            src="../../../assets/img/code.png"
            alt="二维码"
            class="qr-img"
          />
          <div class="qr-label">请扫描上方二维码联系我们</div>
          <button class="close-btn" @click="qrCodeVisible = false">关闭</button>
        </div>
      </div>
  </div>
</template>

<script>
import { getFooterData } from "@/api/index";

export default {
  name: "Footer",

  data() {
    return {
      footerData: {
        phone: "123-456-7890",
        email: "example@example.com",
        address: "默认地址",
        weChatImage: "default-wechat-image.png",
        icp: "默认ICP",
        beianImage: "default-beian-image.png",
        publicSecurity: "默认公安信息",
        copyright: "© 2023 默认版权",
      },
      qrCodeVisible: false,
    };
  },

  mounted() {
    // 获取缓存的数据
    const cachedFooterData = localStorage.getItem("footerData");
    // 如果有缓存的数据，则使用缓存的数据
    if (cachedFooterData) {
      this.footerData = JSON.parse(cachedFooterData);
    } else {
      this.fetchFooterData();
    }
  },

  methods: {
    // 获取Footer数据
    async fetchFooterData() {
      try {
        // 获取Footer数据
        const response = await getFooterData();
        // 如果请求成功，且数据不为空，则更新数据
        if (response.code === 0 && response.data.length > 0) {
          this.footerData = response.data[0];
          // 将数据缓存到localStorage
          localStorage.setItem("footerData", JSON.stringify(this.footerData));
        } else {
          console.error("Failed to fetch footer data:", response.message);
        }
      } catch (error) {
        console.error("Failed to fetch footer data:", error);
      }
    },
    showQrCode() {
      this.qrCodeVisible = true;
    },
    gourl(url) {
    // 新开一个窗口，跳转第三方地址
    window.open(url, '_blank');
    },
	toBn(){
		  window.open('https://beian.miit.gov.cn/', '_blank');
	},
    closeQrCode() {
      this.qrCodeVisible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.footer {
  background: #F8FAFC bottom;
  padding: 61px 0px 0px 30px;
  height: 382px;
  .l {
    width: 1127px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .l_tent {
      width: 394px;
    }
    .l_tent1 {
      width: 514px;
      display: flex;
      justify-content: space-between;
      .link_list{
        width: 85px;
        display: flex;
        flex-direction: column;
        .link_title{
          font-size: 14px;
          color: #1E293B;
          font-weight: 700;
          margin-bottom: 20px;
         
        }
        .link{
          font-size: 14px;
          color: #64748B;
          margin-bottom: 12px;
           cursor: pointer;
        }
      }
    }
  }
}
.r{
  width: 1127px;
  margin: 0 auto;
    display: flex;
    jsutify-content: space-between;
    padding-top: 25px;
    border-top: 1px solid #E2E8F0;
    margin-top: 61px;
    .copyright{
    font-size: 14px;
    color: #94A3B8;
    width: 50%;
    }
    .beian{
        font-size: 14px;
        color: #94A3B8;
    width: 50%;
    text-align: right;
	cursor: pointer;
    }
	.beian:hover{
		color: #6366F1;
	}
}

.qr-code-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2024;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}
.qr-code-dialog {
  background: #fff;
  border-radius: 18px;
  padding: 36px 34px 22px 34px;
  box-shadow: 0 8px 24px rgba(32,40,80,0.19);
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 300px;
  position: relative;
}
.qr-img {
  width: 180px;
  height: 180px;
  object-fit: contain;
  border-radius: 8px;
}
.qr-label {
  margin-top: 18px;
  font-size: 16px;
  color: #464CC5;
  text-align: center;
}
.close-btn {
  margin-top: 22px;
  border: none;
  background: #6366F1;
  color: #fff;
  font-size: 16px;
  border-radius: 8px;
  padding: 8px 22px;
  cursor: pointer;
  outline: none;
}
.close-btn:hover {
  background: #8989ff;
}
</style>